<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.form.$invalid },]")
      vm-col(vm-justify="left", vm-align="center", vm-w=12)
        b-form-group.div__quotation
          vm-select(autocomplete :placeholder='$t("requisition_details.supply_placeholder")' :danger="$v.form.supply_id.$invalid && $v.form.supply_id.$model" :danger-text="$t('validation.required', { attribute: $t('requisition_details.supply') })" v-model="form.supply_id" :label='$t("requisition_details.supply_display")')
            vm-select-item(:key="index" :value="item.id" :text="item.description" v-for="(item,index) in supplies")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(type="number" :placeholder='$t("requisition_details.supply_amount_placeholder")' :danger="$v.form.supply_amount.$invalid && $v.form.supply_amount.$model" :danger-text="$t('validation.required', { attribute: $t('requisition_details.suppy_amount_display') })" v-model="form.supply_amount" :label='$t("requisition_details.supply_amount_display")')
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('RequisitionDetails')

export default {
  name: 'ModalRequisitionDetails',
  mixins: [ModalMixin1],
  // data: () => ({}),
  validations () {
    return {
      form: {
        supply_id: {
          required
        },
        supply_amount: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible', 'catalog', 'supplies'])
  },
  async created () {
    this.getCatalog()
    this.loadSupplies()
  },
  methods: {
    ...mapActions([
      'addRecord',
      'loadSupplies',
      'editRecord',
      'deleteRecord',
      'setModalVisible',
      'loadCatalog'
    ]),
    saveRecord () {
      this.form = {
        ...this.form,
        requisition_id: this.$route.query.requisition_id
      }
      this.isAdd ? this.addRecord(this.form) : this.editRecord(this.form)
    }
  }
}
</script>
